import React, { createContext, useContext, useState } from 'react';
export const context = createContext({});
export function useKnowledgeGraphState() {
    return useContext(context);
}
const StateManager = ({ children }) => {
    const [selectedGraphNodeEntityId, setSelectedGraphNodeEntityId] = useState();
    const [queryResult, setQueryResult] = useState();
    const clearGraphResults = (clear) => {
        if (clear) {
            setQueryResult(null);
            setSelectedGraphNodeEntityId(null);
        }
    };
    return (React.createElement(context.Provider, { value: {
            selectedGraphNodeEntityId,
            setSelectedGraphNodeEntityId,
            queryResult,
            setQueryResult,
            clearGraphResults,
        } }, children));
};
export default StateManager;
